<template>
  <div class="room">
    <div>
      <van-nav-bar
        @click-left="navTo('/')"
        @click-right="navTo('/rule')"
        fixed
        placeholder
        :title="'VIP'+roomId"
      >
        <template #left>
          <van-icon color="#000" name="arrow-left" />
        </template>
        <template #right>
          <div>{{ $t("home.play") }}</div>
        </template>
      </van-nav-bar>
    </div>

    <div>
      <van-image
        width="100%"
        height="180"
        @click="navTo(imageUrl)"
        :src="require('@/assets/VIP'+roomId+'-1.jpg')"
      />
    </div>

    <div
      class="content-section"
      v-for="(item, index) in roomList"
      style="height: 130px; background-color: #2d1c38"
      :key="index"
    >
      <div style="padding: 15px 0 0px 0">
        <van-row  justify="center">
          <van-col span="8">
            <img style="width: 100px; height: 100px" :src='"@/assets/"+index+".png"' />
          </van-col>
          <van-col span="8">
            <div style="height: 100px; color: #fff;">
              {{ item.content.roomName }}
            </div>
          </van-col>
          <van-col span="8">
            <div>
              <van-button
                @click="enterIndoor(item.content.lowestMoney, item.content.roomId)"
                style="width: 100%"
                color="#856660"
                round
                size="small"
                type="info"
                >{{ $t("button.not1") }}:
                {{ item.content.lowestMoney }}</van-button
              >
            </div>
            <div>
              <van-button
                @click="enterIndoor(item.content.minEnterCash, item.content.roomId)"
                style="width: 100%; margin-top: 10px"
                color="#856660"
                round
                size="small"
                type="info"
                >{{ $t("button.not2") }}:
                {{ item.content.minEnterCash }}</van-button
              >
            </div>
          </van-col>
        </van-row>
      </div>
    </div>
  </div>
</template>

<script>
import { sore, roomList } from "@/common/api/api";

export default {
  name: "room",
  data() {
    return {
      gamename: "VIP1",
      imageUrl: "#",
      roomList: [],
      userInfo: "",
      roomId: "",
    };
  },
  created() {
    this.roomId = this.$route.params && this.$route.params.id;
    this.getRoomList();
  },
  methods: {
    navTo(path) {
      this.$router.push(path);
    },
    enterIndoor(val, roomId) {
      const userInfo = this.$store.getters.userInfo;
      sore(userInfo.userId).then((res) => {
        this.userInfo = res.data;
        if (this.userInfo.money > val) {
          this.navTo("/indoor/"+roomId);
        } else {
          this.$toast({
            duration: 5000,
            message: "Tips：Entry limit " + val + " Golds above",
          });
        }
      });
    },
    getRoomList() {
      roomList(this.roomId)
        .then((res) => {
          this.roomList = res.data;
        })
        .catch(() => {});
    },
  },
};
</script>

<style>
.content-section {
  border: 1px solid #eee;
  border-radius: 10px;
  padding: 10px;
  margin: 20px 10px 10px 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* .box {
  position: relative;
}

.child {
  position: absolute;
  top: 50%;
  display: flex;
  flex: 1;
  flex-direction: column; 
  margin-right: 10px; 
  margin: 50px 0 0 0;
} */

.position-style {
  position: relative;
}

.position-style-item {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 200px;
  height: 100px;
  margin-left: -100px;
  margin-top: -50px;
  background-color: #856660;
}
</style>
